<template>
  <div class="form-group" :class="[margin]">
    <!-- Label -->
    <label v-if="label" class="form-label mb-1" :for="'input-'+id" :class="[{ 'col-form-label-sm': small }]">{{ label }}</label>

    <!-- Input Group -->
    <div class="input-group input-group-merge" :class="[{ 'input-group-lg': large, 'input-group-sm': small }]">
      <!-- Input -->
      <input
        v-bind="$attrs"
        :id="'input-'+id"
        :class="[{
          'form-control-appended': icon != 'none',
          'form-control-lg': large,
          'form-control-sm': small,
          'form-control-flush' : flush,
          'is-invalid': status === 'danger',
          'is-focus': isFocus,
          'is-info': status === 'info',
          'is-valid': status === 'success',
          'is-warning': status === 'warning',
          'is-invalid': invalid !== null,
        }]"
        class="form-control"
        :value="value"
        :aria-label="label"
        :type="type"
        :readonly="readonly"
        :disabled="disabled"
        :required="required"
        :placeholder="placeholder"
        :tabindex="tabindex"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
        @keyup="handleChange"
        >

      <!-- Icon -->
      <div v-if="icon != 'none'" class="input-group-append">
        <div class="input-group-text">
          <i :class="[icon]"></i>
        </div>
      </div>
    </div>

    <!-- Help text -->
    <small v-if="help" class="form-text text-muted">{{ help }}</small>

    <!-- Invalid text -->
    <small v-if="invalid" class="form-text text-danger">{{ invalid }}</small>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: null },
    help: { type: String, default: null },
    name: { type: String, default: null },
    id: { type: String, default: null },
    autocomplete: { type: String, default: 'off' },
    disabled: Boolean,
    placeholder: { type: String, default: null },
    readonly: Boolean,
    status: { type: String, default: null },
    icon: { type: String, default: 'none' },
    tabindex: { type: String, default: null },
    type: { type: String, default: 'text' },
    value: { type: [String, Number], default: null },
    required: { type: Boolean, default: false },
    flush: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    margin: { type: String, default: 'mb-4' },
    invalid: { type: [String, Boolean], default: null },
  },
  data() {
    return {
      isFocus: false,
      stringValue: this.value,
    };
  },
  methods: {
    handleChange(e) {
      this.$emit('change', e);
    },
    handleBlur(e) {
      this.isFocus = false;
      this.$emit('blur', e);
    },
    handleFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
    handleInput(e) {
      this.stringValue = e.target.value;
      this.$emit('input', e.target.value);
    },
  },
};
</script>
